export let tuesdayAbbreviatedLowercase = "DC9Ag";
export default {tuesdayAbbreviatedLowercase};